import {URL_API,STATUS_REQUEST,STATUS_SUCCESS,STATUS_FAILURE} from "../constants";
import {RSAA} from "redux-api-middleware";
import {withAuth} from "../reducers";



export const listStatus = () => {
    return ({
        [RSAA]: {
            endpoint: `${URL_API}/status/`,
            method: 'GET',
            headers: withAuth({'Content-Type': 'application/json'}),
            types: [
                STATUS_REQUEST, STATUS_SUCCESS, STATUS_FAILURE
            ]
        }
    })
}



// WEBPACK FOOTER //
// ./src/actions/status.js